// extracted by mini-css-extract-plugin
export default {"footUnit":"AddEnergyModal_footUnit__-4kaU"};